import { useState } from 'react';
import TopBar from './TopBar';
import MainNav from './MainNav';

export default function Header() {
  const [isMegaMenuOpen, setIsMegaMenuOpen] = useState(false);

  return (
    <>
      <TopBar />
      <MainNav 
        isMegaMenuOpen={isMegaMenuOpen}
        setIsMegaMenuOpen={setIsMegaMenuOpen}
      />
    </>
  );
}